<script lang="ts">
  import sessionValues from "$lib/sessionValues";
  import Button from "$lib/Button.svelte";
  let showBrowserValues = $state(false);
</script>

{#snippet liveValue(val?: string)}
  {#if showBrowserValues}
    <code class="block w-fit text-sm px-1 bg-[hsl(0_0_50/.2)]">
      {val || "[ikke lagra]"}
    </code>
  {/if}
{/snippet}

{#snippet tbodyTr(name: string, description: string, func: string, val?: string)}
  <tr>
    <td>{name}</td>
    <td
      >{description}
      {@render liveValue(val)}
    </td>
    <td>{func}</td>
  </tr>
{/snippet}

<details>
  <summary>
    <strong>Nødvendige informasjonskapsler.</strong> Når det er nødvendig, og hvis mulig, lagres «cookieLevels»,
    «consentGranted» og en tabell i «keyval-store» i din nettleser.
  </summary>

  <p>
    Disse lagres når det er funksjonelt nødvendig for dette nettstedet for at den skal kunne
    håndtere den respektive funksjonen i en ny nettleser-sesjon, med mindre nettleseren din ikke
    støtter eller godtar langtidslagring (i noen nettlesere kan det deaktiveres i dens innstilling).
    Hvis nettleseren ikke støtter eller godtar det vil funksjonene nedenfor kun fungere i en og
    samme sesjon.
  </p>

  <p>
    I «cookieLevels» lagres hvilke type cookies du har godtatt. Den vil alltid inneholde
    «nødvendige». Denne lagres i din nettlesers <code>localStorage</code> til du fjerner den.
  </p>

  <p>
    I «consentGranted» lagres «true» eller «false»: «true» hvis du har godkjent
    Cookies/informasjonskapsler for tilpasset annonsering, «false» hvis ikke. Denne lagres i din
    nettlesers <code>localStorage</code> til du fjerner den.
  </p>

  <p>
    I «keyval-store» lagres følgende verdier for følgende funksjoner, disse lagres i <a
      href="https://w3c.github.io/IndexedDB/"
      hreflang="en">Indexeddb</a
    > til de blir fjernet av nettleseren eller deg:
  </p>

  <table>
    <!-- navn, verdi, beskrivelse -->
    <thead>
      <tr>
        <th>Navn</th>
        <th>Verdi</th>
        <th>Funksjon</th>
      </tr>
    </thead>
    <tbody>
      <!-- mnr_type, verdi, lagrer rabattkoden som er aktivert -->
      {@render tbodyTr(
        "mnr_type",
        "Rabattkode",
        "Rabatt i bestillingsskjema",
        $sessionValues.mnr_type
      )}
      <!-- mnr, verdi, lagrer referansenr. for rabatt -->
      {@render tbodyTr(
        "mnr",
        "Referansenr. for rabatt",
        "Rabatt i bestillingsskjema",
        $sessionValues.mnr
      )}
      <!-- product, verdi, lagrer produktnavn -->
      {@render tbodyTr(
        "product",
        "Produktnavn",
        "Produkt i bestillingsskjema",
        $sessionValues.product
      )}
      <!-- product_id, verdi, lagrer produkt-id -->
      {@render tbodyTr(
        "product_id",
        "Produktidentifikator",
        "Produkt i bestillingsskjema",
        $sessionValues.product_id
      )}
      <!-- for cookie consent: cookie_choice, cookie_datetime, cookie_uaId, cookie_version -->
      <!-- cookie_choice, verdi, Cookie valg -->
      {@render tbodyTr(
        "cookie_choice",
        "Cookie valg",
        "Gjeldende cookie valg referanse",
        $sessionValues.cookie_choice
      )}
      <!-- cookie_datetime, verdi, Cookie tidspunkt -->
      {@render tbodyTr(
        "cookie_datetime",
        "Cookie tidspunkt",
        "Tidspunkt for cookie valg",
        $sessionValues.cookie_datetime
      )}
      <!-- cookie_ua, verdi, Cookie ua -->
      {@render tbodyTr(
        "cookie_ua",
        "Nettleser eks. versjonsnummer",
        "Nettleserreferanse for cookie valg",
        $sessionValues.cookie_ua
      )}
      <!-- cookie_version, verdi, Cookie versjon -->
      {@render tbodyTr(
        "cookie_version",
        "Versjonsnavn",
        "Versjon for aktivt valg",
        $sessionValues.cookie_version
      )}
    </tbody>
  </table>

  <p>
    <Button
      class="bg-[hsl(0_0_50/.2)] font-normal"
      onclick={() => (showBrowserValues = !showBrowserValues)}
      >Utvid tabellen med lagrede verdier</Button
    >
  </p>

  <p>
    Disse verdiene kan bli brukt i vår bestillingsløsning der vi bruker <a
      href="https://www.typeform.com/"
      hreflang="en">Typeform</a
    >.
    <a
      href="https://www.typeform.com/help/a/security-privacy-standards-at-typeform-9350912237844/"
      hreflang="en">Typeform oppfyller kravene til GDPR – informasjon på Typeform sine nettsider</a
    > – og da også de norske lovmessige kravene.
  </p>
</details>
